<template>
  <validation-provider
    v-slot="{ errors, valid }"
    :name="question.title"
    :rules="validationRules"
    slim
  >
    <e-select
      :value="value"
      :items="question.options"
      :label="question.title"
      :description="question.description"
      :error-messages="errors"
      :success="valid"
      :is-required="validationRules.required"
      :help-id="helpObject.id"
      :help-function="() => $store.commit('setHelpObject', helpObject)"
      @change="$emit('update', { propertyName: question.propertyName, value: $event })"
    />
  </validation-provider>
</template>

<script>
export default {
  name: 'DynamicSelect',

  props: {
    question: {
      type: Object,
      default: () => ({})
    },

    value: {
      type: String,
      default: ''
    },

    validationRules: {
      type: Object,
      default: () => ({})
    },

    helpObject: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ['change']
}
</script>
